<span class="fl-fixed fc-400 fl fl-ai-c fl-jc-c">
	<ng-content select="[icon]"></ng-content>
</span>

<span class="wrapper-content fl-adaptable fl fl-ai-c fl-jc-fs ellipsis p-2-rl border-box">
	<ng-content></ng-content>
</span>

<span
	class="fl-adaptable fc-400 fl fl-dir-r fl-ai-c fl-jc-fe ellipsis"
	style="flex-grow: 2; flex-shrink: 0"
>
	<ng-content select="[value]"></ng-content>
</span>
